import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import TeamSlideshow from './TeamSlideshow';

const HeroRecruiting = () => {
  return (
    <section className="relative min-h-[92vh] md:min-h-[85vh] flex items-center overflow-hidden bg-foreground">
      {/* Layered green gradient */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse at 20% 20%, hsl(227 78% 52% / 0.35) 0%, transparent 55%), radial-gradient(ellipse at 80% 80%, hsl(227 70% 34% / 0.5) 0%, transparent 60%), linear-gradient(160deg, hsl(220 20% 12%) 0%, hsl(220 25% 8%) 100%)',
        }}
      />

      {/* Subtle grid */}
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            'linear-gradient(hsl(0 0% 100% / 0.4) 1px, transparent 1px), linear-gradient(90deg, hsl(0 0% 100% / 0.4) 1px, transparent 1px)',
          backgroundSize: '80px 80px',
        }}
      />

      <div className="container relative z-10">
        <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-12 items-center pt-32 pb-16 md:pt-40 md:pb-24">
          <div className="max-w-2xl">
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-primary font-semibold mb-6 border border-primary/30 rounded-full px-4 py-1.5 bg-primary/5"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-primary animate-pulse" />
              Wir bauen etwas Großes in Berlin
            </motion.p>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-6 leading-[1.05] tracking-[-0.01em] text-white"
            >
              Wir bauen Berlins stärkste
              <br />
              <span className="italic text-primary">Finanzberatung auf.</span>
              <br />
              Bist du von Anfang an dabei?
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="text-lg md:text-xl text-white/70 max-w-2xl mb-10 leading-relaxed font-light"
            >
              Werde Financial Consultant (m/w/d) bei der Hauptstadt Consulting Partners (HCP) an einem Standort den du wirklich mitgestaltest, selbstständig, ungedeckelt und mit dem System eines etablierten Unternehmens im Rücken.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
              className="flex flex-col sm:flex-row items-start gap-4"
            >
              <Link
                to="/bewerben"
                className="group inline-flex items-center bg-primary text-primary-foreground hover:bg-primary/90 font-semibold text-base px-8 py-4 rounded-xl transition-all duration-300 hover:scale-[1.03] shadow-[0_10px_40px_hsl(227_78%_52%/0.35)]"
              >
                Jetzt bewerben
                <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" />
              </Link>
              <Link
                to="/karriere"
                className="inline-flex items-center text-white/85 hover:text-white font-medium text-base px-6 py-4 rounded-xl border border-white/20 hover:border-white/40 transition-colors"
              >
                Karriere im Detail
              </Link>
            </motion.div>
          </div>

          {/* Desktop image panel */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="hidden lg:block relative"
          >
            <div className="absolute -inset-6 rounded-[2rem] bg-primary/10 blur-2xl pointer-events-none" />
            <div className="relative">
              <TeamSlideshow variant="compact" aspectClassName="aspect-[4/5]" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroRecruiting;
